import { Outlet } from 'libs/router'
import { useAuth } from 'shared/hooks'
import { useFetchMe } from './queries/useFetchMe'
import { usePopulateMe } from './hooks/usePopulateMe'

export const PersistLogin = () => {
	const { setAuth } = useAuth()

	const { me, isMeSuccess } = useFetchMe()

	usePopulateMe({
		isSuccess: isMeSuccess,
		data: me?.data,
		setData: setAuth
	})

	return <Outlet />
}
